export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST';
export const GET_ACTIVE_CATEGORY = 'GET_ACTIVE_CATEGORY';
export const GET_SERVICE_LIST_BY_CATEGORY = 'GET_SERVICE_LIST_BY_CATEGORY';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const ADD_SERVICE = 'ADD_SERVICE';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const MOVE_CATEGORY = 'MOVE_CATEGORY';
export const GET_CATEGORY_LIST_ALL = "GET_CATEGORY_LIST_ALL";
export const GET_SERVICE_LIST = "GET_SERVICE_LIST";
export const GET_SERVICE_INFO = "GET_SERVICE_INFO";
export const DRAG_CATEGORY = "DRAG_CATEGORY";
export const IMPORT_SERVICE = "IMPORT_SERVICE";
export const DRAG_SERVICE = "DRAG_SERVICE";

//POS
export const GET_ALL_CATEGORY_LIST = 'GET_ALL_CATEGORY_LIST';
export const DRAG_PRODUCT = 'DRAG_PRODUCT';

export const GET_CATEGORY_LIST_BY_TYPE = "GET_CATEGORY_LIST_BY_TYPE";
// export const ADD_CATEGORY_POS = "ADD_CATEGORY_POS";
// export const UPDATE_CATEGORY_POS = "UPDATE_CATEGORY_POS";
// export const DELETE_CATEGORY_POS = "DELETE_CATEGORY_POS";
export const GET_PRODUCT_LIST_POS = "GET_PRODUCT_LIST_POS";
export const ADD_PRODUCT_POS = "ADD_PRODUCT_POS";
export const UPDATE_PRODUCT_POS = "UPDATE_PRODUCT_POS";
export const DELETE_PRODUCT_POS = "DELETE_PRODUCT_POS";
export const GET_SERVICE_LIST_POS = "GET_SERVICE_LIST_POS";
export const ADD_SERVICE_POS = "ADD_SERVICE_POS";
export const UPDATE_SERVICE_POS = "UPDATE_SERVICE_POS";
export const DELETE_SERVICE_POS = "DELETE_SERVICE_POS";
export const GET_COMBO_LIST_POS = "GET_COMBO_LIST_POS";
export const ADD_COMBO_POS = "ADD_COMBO_POS";
export const UPDATE_COMBO_POS = "UPDATE_COMBO_POS";
export const DELETE_COMBO_POS = "DELETE_COMBO_POS";

export const GET_GIFTCARD_LIST = "GET_GIFTCARD_LIST";
export const GET_GIFTCARD_DETAIL = "GET_GIFTCARD_DETAIL";
export const DOWNLOAD_GIFTCARD_TEMPLATE = "DOWNLOAD_GIFTCARD_TEMPLATE";
export const EXPORT_GIFTCARD = "EXPORT_GIFTCARD";
export const IMPORT_GIFTCARD = "IMPORT_GIFTCARD";
export const CREATE_GIFTCARD = "CREATE_GIFTCARD";
export const MULTI_CREATE_GIFTCARD = "MULTI_CREATE_GIFTCARD";

export const GET_COMBO_LIST_ACTIVE = "GET_COMBO_LIST_ACTIVE";

export const GET_FULL_CATEGORY_SERVICE_LIST = "GET_FULL_CATEGORY_SERVICE_LIST";